
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { CloseInvoiceRecibePubSub, CurrencyIdPubSub, OpenInvoiceRecibePubSub, OpenInvoiceRecibePubSubPayload } from "@utils/pubsubs/PubSub";
import LoadingScreen from "@components/content/LoadingScreen";
import { SuscriptionDataType } from "@/api/SuscriptionsApi";
import InvoicesRecibeForm from "@components/forms/InvoicesRecibeForm";
import { InvoicesRecibeDataType } from "@/formTypes/InvoicesRecibeFormDataType";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { ClientStatusRowData, InterestConfigType, normalizeClientStatusRow } from "@utils/DocumentStatus";
import { formatMoneyValue } from "@utils/Currency";
import { showAlert } from "@utils/Alert";
import { CLIENT_CREDIT_APPLIED_STATUS, INVOICE_PAYMENT_ACTIVE_STATUS, NORMAL_PRINT_FORMANT_ID, OTHER_PAYMENT_WAY_CODE, RECIBE_DOCUMENT_ID_INDEX, RECIBE_DOCUMENT_INVOICE_TYPE_KEY, RECIBE_DOCUMENT_SETTLEMENT_TYPE_KEY, RECIBE_DOCUMENT_TYPE_INDEX, RECIBE_TYPE_NUMBER_SEPARATOR, TAXES_PERCENTAGES_VALUES, TICKET_PRINT_FORMANT_ID } from "@utils/Constants";
import { RecibeApi, RecibeDataType } from "@/api/RecibeApi";
import { generateNextNumberByModel, omitProperties, toNumberFormat } from "@utils/Utils";
import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import { SettlementApi, SettlementDataType } from "@/api/SettlementApi";
import { InvoicePaymentApi, InvoicePaymentDataType } from "@/api/InvoicePaymentApi";
import { SettlementPaymentApi, SettlementPaymentDataType } from "@/api/SettlementPaymentApi";
import { DocumentsEntryType } from "@components/dynamic/DocumentStatusList";
import { SettlementProductDataType } from "@/api/SettlementProductApi";
import { ProductApi } from "@/api/ProductsApi";
import { InterestEntryApi, InterestEntryDataType } from "@/api/InterestEntryApi";
import { DocumentAutoGeneratedNumberApi } from "@/api/DocumentAutoGeneratedNumberApi";
import { checkRecibeTicketPrint } from "@utils/ticketPrintUtils";
import { resolveDocumentClientNames } from "@utils/documentClientSnapshot";
import { ClientCreditApi } from "@/api/ClientCreditApi";
import { CreditAmountTarget, distributeByBalance } from "@utils/CreditAmount";
import { resolveCurrentUserLabel } from "@utils/Auth";


type InvoiceRecibeOffCanvasProps = {
    suscriptionData: SuscriptionDataType,
    onRecibeCreated?: (generatedRecibe: RecibeDataType) => void,
    manualRecibe?: boolean
} & DefaultOffCanvasProps

const InvoiceRecibeOffCanvas = (props: InvoiceRecibeOffCanvasProps) => {
    const { btnColor = "primary", className, suscriptionData, onRecibeCreated, manualRecibe = false } = props;
    const [isOpen, setOpen] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [generatedInterest, setGeneratedInterest] = useState<number>(0);
    const [recibeDate, setRecibeDate] = useState<string>("");
    const formRef = useRef<DynamicFormRef>(null);
    const [normalizedDocumentsData, setNormalizedDocumentsData] = useState<ClientStatusRowData[]>([])
    const [defaultData, setDefaultData] = useState<InvoicesRecibeDataType>({} as InvoicesRecibeDataType)
    const [recibeLoadData, setRecibeLoadData] = useState<OpenInvoiceRecibePubSubPayload>({} as OpenInvoiceRecibePubSubPayload)

    useEffect(() => {
        const unsubscribe = OpenInvoiceRecibePubSub.subscribe(openOffCanvas);
        const unsubscribeClose = CloseInvoiceRecibePubSub.subscribe(closeOffCanvas);
        return () => {
            unsubscribe();
            unsubscribeClose();
        };
    }, []);

    useEffect(() => {
        if (recibeDate && recibeLoadData.selectedDocuments.length > 0) {
            if (suscriptionData.is_interest_on_due && !suscriptionData.interest_product_id) {
                showAlert("warning", `Por favor dirijase al perfil y seleccione un producto para la 
                    facturacion de intereses,de lo contrario no se creara la liquidacion para intereses automaticamente`);
            }

            const interestConfig: InterestConfigType = {
                interestOnDue: Number(suscriptionData.interest_on_due || 0),
                isInterestOnDue: suscriptionData.is_interest_on_due || false,
                interestExemptedDocuments: recibeLoadData.interestExemptedDocuments
            }
            normalizeData(interestConfig, recibeDate)

        }
    }, [recibeDate, recibeLoadData]);

    const normalizeData = async (interestConfig: InterestConfigType, recibeDate: string) => {
        const normalizedDocumentsData: ClientStatusRowData[] = await Promise.all(recibeLoadData.selectedDocuments.map((r) => normalizeClientStatusRow(recibeDate, r, interestConfig)));
        const totalGeneratedInterest = normalizedDocumentsData.reduce((a, d) => {
            return a + Number(d.interest)
        }, Number(0))
        setGeneratedInterest(totalGeneratedInterest);
        setNormalizedDocumentsData(normalizedDocumentsData);
    }

    const closeOffCanvas = async () => {
        setOpen(false);
    }
    const openOffCanvas = async (payload: OpenInvoiceRecibePubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
        if (openOffCanvas) {
            const defaultData: InvoicesRecibeDataType = {
                fecha: payload.recibeDate,
                monto: payload.recibeTotal
            }
            setRecibeDate(payload.recibeDate)
            setRecibeLoadData(payload)
            setDefaultData(defaultData)
        }
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const onOffCanvasOpened = () => {
        let formDefaultData = {
            ...defaultData
        }
        CurrencyIdPubSub.publish({ currencyId: `${recibeLoadData.recibeCurrency.id}` })
        const payableDocuments = recibeLoadData.selectedDocuments.filter(d => d.kind == "invoice" || d.kind == "settlement");
        if (payableDocuments.length > 0) {
            const lastDocument = payableDocuments[payableDocuments.length - 1];
            formDefaultData = {
                ...formDefaultData,
                factura_abono: `${lastDocument.kind == "invoice" ? `${RECIBE_DOCUMENT_INVOICE_TYPE_KEY}${RECIBE_TYPE_NUMBER_SEPARATOR}` : `${RECIBE_DOCUMENT_SETTLEMENT_TYPE_KEY}${RECIBE_TYPE_NUMBER_SEPARATOR}`}${lastDocument.data.id}`
            }
        }
        formRef.current?.resetFormValue(formDefaultData)

    }

    /**
     * Reparte el saldo a favor seleccionado entre los documentos del recibo y
     * devuelve las filas con el saldo ya rebajado, para que la aritmetica del
     * abono parcial siga cuadrando.
     */
    const buildCreditAllocations = (creditTotal: number, documentRows: ClientStatusRowData[]) => {
        if (creditTotal <= 0) {
            return { allocations: [], adjustedRows: documentRows };
        }

        const targets: CreditAmountTarget[] = documentRows.map(d => ({
            id: d.id,
            numero: d.numero,
            saldo: d.saldo,
            kind: d.kind == "settlement" ? "settlement" : "invoice"
        }));

        const allocations = distributeByBalance(creditTotal, targets);
        const adjustedRows = documentRows.map(d => {
            const allocation = allocations.find(a => a.id == d.id);
            return {
                ...d,
                saldo: Number(toNumberFormat(d.saldo - Number(allocation?.monto || 0)))
            };
        });

        return { allocations, adjustedRows };
    }

    const applyClientCredits = async (
        creditRows: ClientStatusRowData[],
        allocations: ReturnType<typeof buildCreditAllocations>["allocations"],
        generatedRecibe: RecibeDataType,
        recibeDate: string
    ) => {
        if (creditRows.length == 0) {
            return;
        }
        const user = await resolveCurrentUserLabel();

        const paymentPromises = allocations
            .filter(allocation => allocation.monto > 0)
            .map(allocation => {
                const paymentData = {
                    recibeId: generatedRecibe.id,
                    monto: allocation.monto,
                    vuelto: 0,
                    formaPago: `${OTHER_PAYMENT_WAY_CODE}`,
                    currencyId: generatedRecibe.currencyId,
                    exchangeRate: generatedRecibe.exchange_rate,
                    created: recibeDate,
                    estado: INVOICE_PAYMENT_ACTIVE_STATUS,
                    descripcion: `Aplicacion de saldo a favor por recibo #${generatedRecibe.numero}`,
                    user
                };
                if (allocation.kind == "settlement") {
                    const payment: SettlementPaymentDataType = omitProperties({
                        ...paymentData,
                        settlementId: allocation.id,
                    }, [], true);
                    return SettlementPaymentApi.create(payment);
                }
                const payment: InvoicePaymentDataType = omitProperties({
                    ...paymentData,
                    invoiceId: allocation.id,
                }, [], true);
                return InvoicePaymentApi.create(payment);
            });

        const creditPromises = creditRows.map(credit => ClientCreditApi.update(`${credit.id}`, {
            aplicado: Math.abs(Number(credit.total || 0)),
            estado: CLIENT_CREDIT_APPLIED_STATUS,
            recibeId: generatedRecibe.id,
            recibeNumero: `${generatedRecibe.numero}`
        }));

        await Promise.all([...paymentPromises, ...creditPromises]);
    }

    const onInvoiceRecibeSubmit = async (formData?: InvoicesRecibeDataType) => {
        if (formData) {
            const { recibeTotal } = recibeLoadData
            // Los saldos a favor entran como filas negativas: no se cobran ni se marcan como pagados.
            const selectedDocuments = (recibeLoadData.selectedDocuments || []).filter(d => d.kind != "clientCredit")
            const creditRows = normalizedDocumentsData.filter(d => d.kind == "clientCredit")
            const documentRows = normalizedDocumentsData.filter(d => d.kind != "clientCredit")
            const creditTotal = Number(toNumberFormat(creditRows.reduce((a, d) => a + Math.abs(Number(d.saldo || 0)), Number(0))))
            const documentsTotal = Number(toNumberFormat(documentRows.reduce((a, d) => a + Number(d.saldo || 0), Number(0))))

            if (creditTotal > 0 && creditTotal >= documentsTotal) {
                showAlert("danger", `El saldo a favor cubre el total de los documentos seleccionados;
                    deseleccione documentos o use un saldo a favor menor`);
                return;
            }

            const { allocations: creditAllocations, adjustedRows } = buildCreditAllocations(creditTotal, documentRows)

            let motivo = "Pago "
            const recibeMonto = Number(formData?.monto)

            let isPartialPayment = false
            let abonoDocumentData: ClientStatusRowData = {} as ClientStatusRowData;
            let partialPaymentAmount;
            let abonoDocumentParts: string[] = [];
            if (recibeTotal > recibeMonto) {
                isPartialPayment = true
                if (selectedDocuments.length == 1) {
                    motivo = "Abono "
                } else {
                    motivo = "Pago y Abono ";
                }

                const documentIdPartialPay = `${formData?.factura_abono}`
                abonoDocumentParts = documentIdPartialPay.split(RECIBE_TYPE_NUMBER_SEPARATOR)
                abonoDocumentData = adjustedRows.find(d => d.id == abonoDocumentParts[RECIBE_DOCUMENT_ID_INDEX]) || {} as ClientStatusRowData
                partialPaymentAmount = Number(toNumberFormat(recibeLoadData.recibeTotal - recibeMonto))
                if (Number(toNumberFormat(abonoDocumentData?.saldo || 0)) < partialPaymentAmount) {
                    showAlert("danger", `El monto del abono supero el monto del saldo de la 
                    ${abonoDocumentData?.kind == "settlement" ? 'Liquidacion' : 'Factura'}  #${abonoDocumentData?.numero}`);
                    return;
                }
            }

            let defaultDocumentList: Record<string, string[]> = { invoices: [], settlements: [] }
            const documentOnRecibe = adjustedRows.reduce((a, d) => {
                if (d.kind == "settlement") {
                    a.settlements.push(d.numero)
                } else {
                    a.invoices.push(d.numero)
                }
                return a
            }, defaultDocumentList)

            motivo += Object.entries(documentOnRecibe).map(([type, values]) => {
                if (values.length == 0) {
                    return ""
                }
                const documentTitle = type == "settlements" ? "Liquidacion(es) numero: " : "Factura(s) numero: "
                return `${documentTitle}${values.join(",")}`
            }).join(" ")

            const documentTotal = adjustedRows.reduce((a, d) => {
                return a + Number(toNumberFormat(d.total))
            }, Number(0))

            setLoading(true)
            try {
                const document = selectedDocuments.find((d) => d.kind == "invoice" || d.kind == "settlement")
                const clientId = document?.data.clientId

                let recibe: RecibeDataType = {
                    ...formData,
                    nombre: document?.data?.client?.nombre,
                    abono: Number(formData?.monto),
                    total: documentTotal,
                    clientId: clientId,
                    motivo: motivo,
                    created: formData?.fecha,
                }

                recibe = omitProperties(recibe, ["factura_abono", "fecha", "monto"])

                const generatedRecibe = await RecibeApi.createClientRecibe(recibe)

                await applyClientCredits(creditRows, creditAllocations, generatedRecibe, `${formData?.fecha}`);

                await markDocumentAsPayed(isPartialPayment, abonoDocumentParts, abonoDocumentData, generatedRecibe, recibeMonto, selectedDocuments, adjustedRows);

                const { interest_on_due, is_interest_on_due, interest_product_id } = suscriptionData
                if (generatedInterest > 0 && is_interest_on_due && interest_on_due && interest_product_id) {
                    const generatedSettlement = await generateInterestSettlement(interest_product_id, `${clientId}`, document, generatedInterest, generatedRecibe, formData, documentRows);

                    showAlert("success", `Se ha generado el recibo exitosamente, ademas se genero la liquidacion #${generatedSettlement.numero}
                            por los intereses generados por los documentos vencidos`);
                } else {
                    showAlert("success", `Se ha generado el recibo #${generatedRecibe.numero} Exitosamente`);
                }
                if (onRecibeCreated) {
                    onRecibeCreated(generatedRecibe);
                }
                checkRecibeTicketPrint(suscriptionData, generatedRecibe)
                if (suscriptionData?.formato_impresion === NORMAL_PRINT_FORMANT_ID) {
                    window.open(`/user/recibes/view/${generatedRecibe.id}`, "print-recibe")
                }

            } catch (err) {
                if (err instanceof Error) {
                    showAlert("danger", err.message);
                }
            } finally {
                setLoading(false)
            }
        }
    }

    const generateInterestSettlement = async (interest_product_id: string, clientId: string, document: { kind: "invoice"; data: InvoiceDataType; } | { kind: "settlement"; data: SettlementDataType; } | undefined, generatedInterest: number, generatedRecibe: RecibeDataType, formData: InvoicesRecibeDataType, normalizedDocumentsData: ClientStatusRowData[]) => {
        const interestProduct = await ProductApi.get(interest_product_id);
        const interestSettlement: SettlementDataType = omitProperties({
            tipo: "1",
            clientId: clientId,
            nombre_factura: resolveDocumentClientNames(document?.data?.client || {}).nombre_factura,
            tel1: document?.data?.client?.tel1,
            email: document?.data?.client?.email,
            direccion: document?.data?.client?.direccion,
            porcenta_descuento: 0,
            descuento: 0,
            subtotal: generatedInterest,
            total: generatedInterest,
            impuestos: 0,
            impuestos_servicio: 0,
            anulada: false,
            tipo_identificacion: document?.data?.client?.tipo_identificacion,
            identificacion: document?.data?.client?.identificacion,
            pagada: false,
            status: "pendiente",
            exenta: false,
            currencyId: generatedRecibe.currencyId,
            exchange_rate: generatedRecibe.exchange_rate,
            document_comments: `Liquidacion por intereses generados al ${formData?.fecha} por ${generatedRecibe.motivo}`,
            plazo: 1,
            interest_exempt: true,
            fecha: formData?.fecha
        }, [], true);

        const settlementProducts = normalizedDocumentsData.filter(nd => nd.interest > 0).map(nd => {
            const settlemetProduct: SettlementProductDataType = {
                description: `Intereses generados por ${nd.diasVencida} dia(s) sobre 
                            ${nd.kind == "settlement" ? "liquidacion" : "factura"} #${nd.numero}`,
                codigo_cabys: interestProduct.codigo_cabys,
                productId: interestProduct.id,
                cant: 1,
                price: nd.interest,
                subtotal: nd.interest,
                impuestos: 0,
                impuestos_servicio: 0,
                porcentaje_descuento: 0,
                descuento: 0,
                shipping_cost: 0,
                tipo_producto: interestProduct.tipo_producto,
                exento: true,
                tipo_impuesto: interestProduct.tipo_impuesto,
                porcentaje_impuesto: TAXES_PERCENTAGES_VALUES[`${interestProduct.tipo_impuesto}`],
                codigo_tarifa: `${interestProduct.porcentaje_impuesto}`,
                unidad_medida: `${interestProduct.unidad_medida}`
            };
            return omitProperties(settlemetProduct, [], true);
        });
        const generatedSettlement = await SettlementApi.createSettlementAndProducts(interestSettlement, settlementProducts);

        let generatedInterestNumber = await generateNextNumberByModel("InterestEntry");
        if (!generatedInterestNumber?.number) {
            throw Error(`No fue posible generar el identificador de Intereses`)
        }
        let interestNumber = generatedInterestNumber?.number;

        const interestEntriesPromises = normalizedDocumentsData.filter(nd => nd.interest > 0).map(nd => {
            const interestEntries: InterestEntryDataType = {
                numero: interestNumber++,
                recibeId: generatedRecibe.id,
                settlementInterestId: generatedSettlement.id,
                days: nd.diasVencida,
                amount: nd.interest,
                currencyId: nd.currency.id,
                created: generatedRecibe.created
            };
            return InterestEntryApi.create({
                ...interestEntries,
                [nd.kind == "settlement" ? "settlementId" : "invoiceId"]: nd.id
            })
        });
        await Promise.all(interestEntriesPromises);
        generatedInterestNumber.number = interestNumber;
        await DocumentAutoGeneratedNumberApi.save(generatedInterestNumber)
        if (suscriptionData?.id && generatedRecibe?.id) {
            if (suscriptionData.formato_impresion == TICKET_PRINT_FORMANT_ID) {
                checkRecibeTicketPrint(suscriptionData, generatedRecibe)
            } else {
                window.open(`/user/recibes/print/${generatedRecibe.id}`, `_blank`)
            }
        }
        return generatedSettlement;
    }

    const markDocumentAsPayed = async (isPartialPayment: boolean, abonoDocumentParts: string[], abonoDocumentData: ClientStatusRowData, generatedRecibe: RecibeDataType, recibeMonto: number, selectedDocuments: DocumentsEntryType[], documentsData: ClientStatusRowData[]) => {
        let relativeDataPromises = [];

        if (isPartialPayment) {
            if (abonoDocumentParts.length > 0 && abonoDocumentData?.id) {
                const fullPayDocuments = selectedDocuments.filter(d => d.data.id != abonoDocumentData.id);
                const fullPayDocumentTotal = documentsData.filter(d => d.id != abonoDocumentData.id).reduce((a, d) => {
                    return a + Number(toNumberFormat(d.saldo))
                }, Number(0))

                const paymentData = {
                    recibeId: generatedRecibe.id,
                    monto: recibeMonto - fullPayDocumentTotal,
                    vuelto: 0,
                    formaPago: generatedRecibe.forma_pago,
                    numAprobacion: generatedRecibe.reference,
                    bankAccountId: generatedRecibe.bankAccountId,
                    currencyId: generatedRecibe.currencyId,
                    creditOperatorId: generatedRecibe.creditOperatorId,
                    exchangeRate: generatedRecibe.exchange_rate,
                    created: generatedRecibe.created,
                    estado: INVOICE_PAYMENT_ACTIVE_STATUS,
                    descripcion: `Abono por recibo #${generatedRecibe.numero}`,
                };
                if (abonoDocumentParts[RECIBE_DOCUMENT_TYPE_INDEX] == RECIBE_DOCUMENT_INVOICE_TYPE_KEY) {
                    const payment: InvoicePaymentDataType = omitProperties({
                        ...paymentData,
                        invoiceId: abonoDocumentData.id,
                    }, [], true);
                    relativeDataPromises.push(InvoicePaymentApi.create(payment));
                } else {
                    const payment: SettlementPaymentDataType = omitProperties({
                        ...paymentData,
                        settlementId: abonoDocumentData.id,
                    }, [], true);
                    relativeDataPromises.push(SettlementPaymentApi.create(payment));
                }

                const relativeDocumentUpdates = generateMarkDocumentAsPayedPromise(fullPayDocuments, generatedRecibe);
                relativeDataPromises.push(...relativeDocumentUpdates);
            }
        } else {
            const relativeDocumentUpdates = generateMarkDocumentAsPayedPromise(selectedDocuments, generatedRecibe);
            relativeDataPromises.push(...relativeDocumentUpdates);
        }

        await Promise.all(relativeDataPromises);
    }

    const generateMarkDocumentAsPayedPromise = (selectedDocuments: DocumentsEntryType[], generatedRecibe: RecibeDataType) => {
        return selectedDocuments.map(d => {
            if (d.kind == "invoice" || d.kind == "settlement") {
                const documentUpdate = {
                    id: d.data.id,
                    recibeId: generatedRecibe.id,
                    pagada: true,
                    status: "pagada",
                    clientId: d.data.clientId,
                    fecha: d.data.fecha,
                    // Parte del sort key `user#fecha`: se reenvia el guardado para conservar
                    // al creador en vez de estampar a quien aplica el recibo.
                    user: d.data.user,
                    reference_number: d.data.reference_number || "noRef"
                }
                if (d.kind == "invoice") {
                    return InvoiceApi.update(`${documentUpdate.id}`, documentUpdate)
                } else if (d.kind == "settlement") {
                    return SettlementApi.update(`${documentUpdate.id}`, documentUpdate)
                }
            }
        })
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onOpened={onOffCanvasOpened}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Desea Crear Recibo
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <p>
                            Por favor ingrese la informacion de la forma de pago.
                        </p>
                        <InvoicesRecibeForm
                            ref={formRef}
                            onRecibeDateChange={(value) => setRecibeDate(value)}
                            onInvoiceRecibeSubmit={onInvoiceRecibeSubmit}
                            recibeTotal={recibeLoadData.recibeTotal}
                            selectedDocuments={recibeLoadData.selectedDocuments}
                            manualRecibe={manualRecibe}
                        />
                        {generatedInterest > 0 && (<Alert className="mt-4" color="warning">
                            <b>Advertencia!</b> La facturas seleccionas tiene un total de intereses pendiente por <b>{formatMoneyValue(generatedInterest, recibeLoadData.recibeCurrency.currency_id || 1)}</b>
                            por lo cual al cancelar estas facturas se creara una liquidacion por el monto anteriorment mencionado.
                        </Alert>)}
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
            <LoadingScreen isLoading={isLoading} />
        </>
    );
}
export default InvoiceRecibeOffCanvas;

